import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link as A } from 'react-router-dom';

// style
import './style.scss';

// components
import ProjectBox from '../../components/ProjectBox';
import ProjectShowcase from '../../components/ProjectShowcase';
import Spinner from '../../components/Spinner';
import Pagination from './Pagination';

export default function AllProjects() {
  const project = useSelector((state) => state.project);

  const [Projects, setProjects] = useState([]);
  let [currentPage, setCurrentPage] = useState(1);
  const [projectsPerPage] = useState(6);

  useEffect(() => {
    setProjects(project.projects);
  }, [project.projects]);

  // Get current projects
  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = Projects.slice(
    indexOfFirstProject,
    indexOfLastProject
  );

  //change page
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const decrementPaginate = () => {
    if (currentPage === 1) {
      return setCurrentPage(1);
    }
    setCurrentPage(--currentPage);
  };

  const incrementPaginate = () => {
    setCurrentPage(++currentPage);
  };

  return (
    <div id="projects">
      <div className="overlay"></div>
      <div className="container">
        <A className="go-back" to="/">
          <span>
            <i className="fas fa-arrow-left"></i>
          </span>
          Go Back
        </A>
        <ProjectShowcase>
          {currentProjects.map((project) => (
            <ProjectBox
              key={project._id}
              name={project.name}
              projectImage={project.projectImage}
              details={project.projectDetails}
              createdWith={project.createdWith}
              alt={project.ImageAlt}
              gitlink={project.gitLink}
              live={project.projectLink}
            />
          ))}
        </ProjectShowcase>
        <Pagination
          projectsPerPage={projectsPerPage}
          totalProjects={Projects.length}
          paginate={paginate}
          decrementPaginate={decrementPaginate}
          incrementPaginate={incrementPaginate}
          currentPage={currentPage}
        />
        {project.loading && <Spinner />}
      </div>
    </div>
  );
}
